import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AdviceSection from '../common/AdviceSection';
import SubMenuTabs from '../common/subMenuTabs/SubMenuTabs';
import SelectEconomic from '../common/select-filters/SelectEconomic';
import CountryProfileTextTab from '../common/CountryProfileTextTab';
import Methodology from '../common/Methodology';
import Related from '../common/Related.js';

import { enforcementAuthoritiesTabs } from '../../model/subMenuTabs';

import { getOSHData } from '../../api';

import { setCountry1, setCountry2, setCountry3 } from '../../actions/';

const EnforcementAuthorities = props => {

	const currentPath = '/osh-infrastructure/enforcement-authorities/';
	// Get global state for the selects
	const { selectCountry, selectCountry2, selectCountry3, selectedByUser, lockedCountry } = useSelector((state) => state.selectCountries);
	const [countryLocked, setCountryLocked] = useState(lockedCountry);
	const [isLoaded, setIsLoaded] = useState(false);
	const [selectedTab, setSelectedTab] = useState(undefined);
	const [countryText1, setCountryText1] = useState({});
	const [countryData1, setCountryData1] = useState({});
	const [noInfoTexts1, setNoInfoTexts1] = useState([]);
	const [countryText2, setCountryText2] = useState({});
	const [countryData2, setCountryData2] = useState({});
	const [noInfoTexts2, setNoInfoTexts2] = useState([]);
	const [countryText3, setCountryText3] = useState({});
	const [countryData3, setCountryData3] = useState({});
	const [noInfoTexts3, setNoInfoTexts3] = useState([]);
	const [filters, setFilters] = useState({
		countries: [
			{ code: props.country1 ? props.country1 : 'AT' },
			{ code: props.country2 ? props.country2 : '0' },
			{ code: props.country3 ? props.country3 : '0' }
		]
	})
	
	// Hook for the dispatchs
	const dispatch = useDispatch();

	useEffect(() => {
		let selected = enforcementAuthoritiesTabs.find((tab) => tab.url == props.indicator);
		if (selected)
		{
			setSelectedTab(selected);
		}

		if (selected.url == 'authority' || selected.url == 'scope-of-the-labor-inspection' 
			|| selected.url == 'inspector-powers' || selected.url == 'strategy-plan') {
			getStrategiesData();
		}

		if (!selectedByUser) {
			if (props.country1 != undefined && props.country1 != '') {
				dispatch(setCountry1(props.country1))
			}
		}

		if (props.country2 != undefined && props.country2 != '') {
			dispatch(setCountry2(props.country2))
		}

		if (props.country3 != undefined && props.country3 != '') {
			dispatch(setCountry3(props.country3))
		}
		
		// Update the title of the page
		document.title = props.literals.L20780 +  " - " + props.literals.L22020 + " - " + props.literals.L363;

		setIsLoaded(true);
	}, []);

	useEffect(() => {
		getStrategiesData();
	}, [selectedTab, selectCountry, selectCountry2, selectCountry3, countryLocked, selectedByUser])

	const handleSearch = (callbackCountry1) => {
		if (selectedByUser) {
			setCountryLocked(callbackCountry1);
		} else {
			dispatch(setCountry1(callbackCountry1));
		}
		setFilters({
			countries: [ { code: callbackCountry1 }, filters.countries[1], filters.countries[2] ]
		});
	}

	const handleSearch2 = (callbackCountry2) => {
		dispatch(setCountry2(callbackCountry2));
		setFilters({
			countries: [ filters.countries[0], {code: callbackCountry2}, filters.countries[2] ]
		});
	}

	const handleSearch3 = (callbackCountry3) => {
		dispatch(setCountry3(callbackCountry3));
		setFilters({
			countries: [ filters.countries[0], filters.countries[1], {code: callbackCountry3} ]
		});
	}

	const callbackSelectedTab = (callback) => {
		const selected = enforcementAuthoritiesTabs.find((tab) => tab.url == callback);
		if (selected)
		{
			setSelectedTab(selected);
		}
	}

	const getStrategiesData = () => {
		getOSHData('STRATEGY_ENFOR_CAPACITY', filters)
		.then((res) => {
			const countriesData = res.resultset;
			const selectCountry1 = selectedByUser ? countryLocked : selectCountry;

			// If there's no Data on both selected countries on mount times
			if (countriesData.length == 0) {
				setCountryData1({ code: selectCountry1, name: ''});
				setCountryText1('');
				setCountryData2({ code: selectCountry2, name: '' });
				setCountryText2('');
				setCountryData3({ code: selectCountry3, name: '' });
				setCountryText3('');
				setNoInfoTexts1(['20706', '20740']);
				setNoInfoTexts2(['20706', '20740']);
				setNoInfoTexts3(['20706', '20740']);
			} 
			else if (countriesData.length > 0 && selectCountry2 == '0') {
				setCountryText2(null);
				setCountryData2(undefined);
			}
			else if (countriesData.length > 0 && selectCountry3 == '0') {
				setCountryText3(null);
				setCountryData3(undefined);
			}

			const indexCountry1 = countriesData.findIndex((element) => element.country.code == selectCountry1)
			const indexCountry2 = countriesData.findIndex((element) => element.country.code == selectCountry2)
			const indexCountry3 = countriesData.findIndex((element) => element.country.code == selectCountry3)

			let textToLoad = '';
			// Depending on the selected tab, we know what text needs to be loaded
			if (selectedTab)
			{
				if (selectedTab.url == 'authority') {
				textToLoad = 'text1';
				} else if (selectedTab.url == 'scope-of-the-labor-inspection') {
					textToLoad = 'text2';
				} else if (selectedTab.url == 'inspector-powers') {
					textToLoad = 'text3';
				} else if (selectedTab.url == 'strategy-plan') {
					textToLoad = 'text4';
				}
			}

			if (textToLoad != '' && countriesData[indexCountry1] != undefined && props.literals[`L${countriesData[indexCountry1][textToLoad]}`] != undefined && props.literals[`L${countriesData[indexCountry1][textToLoad]}`] != '') {
				// There is data for the country and the text is not empty
				setCountryData1(countriesData[indexCountry1].country);
				setCountryText1(countriesData[indexCountry1][textToLoad]);
				setNoInfoTexts1([]);
			} else {
				setCountryData1( { code: selectedByUser ? lockedCountry : selectCountry, name: '' } );
				setCountryText1('');
				setNoInfoTexts1( ['20706' ,'20740'] );
			}

			if (textToLoad != '' && countriesData[indexCountry2] != undefined && props.literals[`L${countriesData[indexCountry2][textToLoad]}`] != undefined && props.literals[`L${countriesData[indexCountry2][textToLoad]}`] != '') {
				// There is data for the country and the text is not empty
				setCountryData2(countriesData[indexCountry2].country);
				setCountryText2(countriesData[indexCountry2][textToLoad]);
				setNoInfoTexts2([]);
			} else {
				setCountryData2( { code: selectCountry2, name: '' } );
				setCountryText2('');
				setNoInfoTexts2( ['20706' ,'20740'] );
			}

			if (textToLoad != '' && countriesData[indexCountry3] != undefined && props.literals[`L${countriesData[indexCountry3][textToLoad]}`] != undefined && props.literals[`L${countriesData[indexCountry3][textToLoad]}`] != '') {
				// There is data for the country and the text is not empty
				setCountryData3(countriesData[indexCountry3].country);
				setCountryText3(countriesData[indexCountry3][textToLoad]);
				setNoInfoTexts3([]);
			} else {
				setCountryData3( { code: selectCountry3, name: '' } );
				setCountryText3('');
				setNoInfoTexts3( ['20706' ,'20740'] );
			}
		})
	}

	if (!isLoaded)
	{
		return null;
	}
	
	const selectCountry1 = selectedByUser ? countryLocked : selectCountry;
	return(
		<div className="country--profile--page enforcement-capacity">
			<AdviceSection literals={ props.literals } section={["osh-infrastructure","enforcement-authorities"]} methodologyData={{section: 'osh-infrastructure', subsection: 'Enforcement authorities', indicator: 76}} />

			<div>
				<SubMenuTabs 
					literals={ props.literals }
					selectedTab={ selectedTab.url }
					callbackSelectedTab={ callbackSelectedTab }
					locationPath={ currentPath }
					subMenuTabs={ enforcementAuthoritiesTabs } 
					selectCountry1={ selectCountry1 }
					selectCountry2={ selectCountry2 }
					selectCountry3={ selectCountry3 }
				/>
			</div>

			<div className="line background-main-light"></div>

			<div>
				<SelectEconomic 
					handleSearch={ handleSearch }
					handleSearch2={ handleSearch2 }
					handleSearch3={ handleSearch3 }
					literals={ props.literals }
					selectedCountry1={ selectCountry1 }
					selectedCountry2={ selectCountry2 }
					selectedCountry3={ selectCountry3 }
				/>
			</div>

			<div className="line background-main-light"></div>

			<div className="container section--page card--grid xxs-w1 xs-w1 w1">
				{ enforcementAuthoritiesTabs.map((element) => {
					if (element.url == selectedTab.url) {
						return (
							<div key={element.literalTab} className="container section--page full-tablet" >
								<CountryProfileTextTab 
									tabName={ element.literalTab }
									literals={ props.literals }
									country1Text={ countryText1 }
									country2Text={ countryText2 }
									country3Text={ countryText3 }
									country1={ countryData1 }
									country2={ countryData2 }
									country3={ countryData3 }
									noInfoMsg1={ noInfoTexts1 }
									noInfoMsg2={ noInfoTexts2 }
									noInfoMsg3={ noInfoTexts3 }
									maxCharacters={ 400 }
									page={ 'enforcement' }
								/>
							</div>
						)
					}
				})}	
			</div>

			<Methodology literals={ props.literals } section={'Enforcement authorities'} indicator={ selectedTab.indicator }/>
			<Related literals={ props.literals } section={["osh-infrastructure","enforcement-authorities", selectedTab.url]} country1={ props.selectedByUser ? lockedCountry : props.selectCountry } country2={ props.selectCountry2 } country3={ props.selectCountry3 } />
		</div>
	)
}
EnforcementAuthorities.displayName = 'EnforcementAuthorities';
export default EnforcementAuthorities;